import { render, staticRenderFns } from "./StatusQuantity.vue?vue&type=template&id=2b8573fc&scoped=true"
import script from "./StatusQuantity.vue?vue&type=script&lang=js"
export * from "./StatusQuantity.vue?vue&type=script&lang=js"
import style0 from "./StatusQuantity.vue?vue&type=style&index=0&id=2b8573fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8573fc",
  null
  
)

export default component.exports